import React from 'react';

import { DEFAULT_MESSAGE } from './constants';

export interface Props {
  inputWidth: number;
  message?: string;
}

const NoResultsFound: React.FC<Props> = ({ inputWidth, message = DEFAULT_MESSAGE }) => (
  <div
    className="absolute bg-white rounded-md border border-gray-300 shadow-md mt-1 px-1 py-6 z-10 text-center"
    style={{
      minWidth: inputWidth || 'auto',
    }}
  >
    <p className="font-bold text-gray-850 mb-1">{message}</p>

    <p className="font-medium text-gray-600">
      If this an error, reach out to us at{' '}
      <a
        className="text-blue-200 font-medium"
        href="mailto:provider@joinmodernhealth.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        provider@joinmodernhealth.com
      </a>
    </p>
  </div>
);

export default NoResultsFound;
